module.exports = __webpack_public_path__ + "static/media/onionskinning.2358c4ab.svg";